import { NetworkError } from '@/errors';
import { useMerchantStore } from '@/stores/merchants';
import { useUserStore } from '@/stores/users';
import { addMetric, createException, createWarning } from '@/utils/monitoring.utils';

/**
 * Route guard that ensures merchant data (including settings) is loaded before
 * entering merchant dashboard routes. Handles the case where merchant signs in
 * with 2FA and merchant data is not fetched after OTP verification.
 * Skips fetching if merchant data is already loaded for the active merchant.
 */
export const initializeMerchantGuard = async () => {
  const userStore = useUserStore();
  const merchantStore = useMerchantStore();

  const merchantId = merchantStore.activeMerchantId || userStore.user.merchantIds?.[0];
  if (!merchantId) return;

  if (merchantStore.merchant?._id === merchantId) return;

  try {
    await merchantStore.onChangeMerchant(merchantId);
    addMetric('merchant-guard', { status: 'success' });
  } catch (error: any) {
    if (error instanceof NetworkError) {
      createWarning(error);
      addMetric('merchant-guard', { status: 'network_error' });
    } else {
      createException(error);
      addMetric('merchant-guard', { status: 'error' });
    }
    return { name: 'merchantSignIn' };
  }
};
